// frontend/src/components/sync/phaseCopy.js
//
// How a catalog phase's counts read, shared by the price-wait screen
// (`SyncScreen`) and the sidebar's `SyncProgressPill`.
//
// COUNTED NOUNS: every "{n} products" is its own `t(key, { count })` so
// Polish and Dutch pick their plural forms; two counts on one line are
// translated separately and joined.

// The noun each progress counter prints as. Literal keys, so the audit sees
// every one of them.
const COUNT_KEYS = {
  locations: 'syncScreen.counts.locations',
  products: 'syncScreen.counts.products',
  variants: 'syncScreen.counts.variants',
  inventory: 'syncScreen.counts.records',
};

/**
 * The phase's counters as counted nouns, joined.
 *
 * @param {Function} t
 * @param {Function} formatNumber  `useFormatters().formatNumber`
 * @param {{counters: string[]}} phase  a `utils/syncGate.CATALOG_PHASES` entry
 * @param {object} progress  the payload's `sync.progress`
 * @param {Function} read  `(progress, name) => number`: `utils/syncGate`
 *   `visitedCount` or `changedCount`
 */
export function phaseNouns(t, formatNumber, phase, progress, read) {
  return phase.counters
    .map((name) => {
      const n = read(progress, name);
      return t(COUNT_KEYS[name], { count: n, formatted: formatNumber(n, 0) });
    })
    .join(' · ');
}
